import { useState } from 'react';
import { NudosButton, NudosTextInput } from '../../../../../components/NudosComponents';
import { isEmailValid } from '../../../../../utils/formValidations';
import errorMessage from '../../../../../utils/errorMessage';
import { addUserToBackoffice } from '../../../../../services/configuration.service';
import { isEditingInThisModuleAllowed } from '../../../../LogisticServices/utils/general.utils';
import './AddUserToBackofficeSection.scss';

const AddUserToBackofficeSection = ({ updateDataCallback }: { updateDataCallback?: () => void }) => {
  const [email, setEmail] = useState<string>();
  const [loading, setLoading] = useState(false);

  const validEmail = isEmailValid(email || '');
  const emailError = email && !validEmail ? 'Escribe un email válido' : undefined;

  const isButtonDisabled = !validEmail || loading || !isEditingInThisModuleAllowed();

  const giveEmailBackofficeAccess = async () => {
    if (!email || !validEmail) return;
    try {
      setLoading(true);
      await addUserToBackoffice(email);
      updateDataCallback && updateDataCallback();
    } catch {
      errorMessage();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="addUserToBackofficeSection">
      <div className="sectionTitle">Agregar usuario al backoffice</div>
      <div className="instructions">
        Recuerda que el usuario debe contar con un correo registrado en nuestra base de datos para poder ingresar al
        backoffice
      </div>
      <div className="fieldAndButton">
        <NudosTextInput
          componentSize="medium"
          label="Correo"
          placeholder={'nombre@correo.com'}
          isFilled={!!email}
          errorText={emailError}
          handleChange={setEmail}
        />
        <NudosButton
          buttonText="Guardar"
          customWidth="64px"
          customHeight="20px"
          handleClick={giveEmailBackofficeAccess}
          isButtonDisabled={isButtonDisabled}
          isButtonLoading={loading}
        />
      </div>
    </div>
  );
};

export default AddUserToBackofficeSection;
